/*! Lazy Image */
class LazyImage extends HTMLImageElement {
  connectedCallback() {
    // connectedCallback fires after the element is in the DOM, so
    // closest() and complete/naturalWidth are reliable — even on first visit.
    this.wrapper = this.closest('.media-wrapper');
    if (this.wrapper === null) return;

    this._lazyBound = this.handleLazy.bind(this);
    this.handleLazy();
    addEventListener('resize', this._lazyBound, true);

    if (!this._observer) {
      this._observer = new MutationObserver((changes) => {
        changes.forEach((change) => {
          if (change.attributeName.includes('src') || change.attributeName.includes('srcset')) {
            this.handleLazy();
          }
        });
      });
      this._observer.observe(this, { attributes: true });
    }
  }

  disconnectedCallback() {
    if (this._lazyBound) removeEventListener('resize', this._lazyBound, true);
    if (this._observer) { this._observer.disconnect(); this._observer = null; }
  }

  handleLazy() {
    const mql = window.matchMedia('(min-width: 750px)');
    if (mql.matches && this.classList.contains('medium-hide')) return;
    if (!mql.matches && this.classList.contains('small-hide')) return;

    // If already loaded (cached or fast network), clear state immediately — no spinner needed
    if (this.complete) {
      if (this.naturalWidth > 0) {
        this.classList.add('loaded');
        this.wrapper.classList.remove('loading');
      }
      return;
    }

    if (this.classList.contains('loaded')) return;

    this.wrapper.classList.add('loading');

    const clearLoading = () => {
      this.classList.add('loaded');
      this.wrapper.classList.remove('loading');
    };

    this.addEventListener('load', clearLoading, { once: true });

    // Safety: remove spinner on error so card is never permanently stuck
    this.addEventListener('error', () => {
      this.wrapper.classList.remove('loading');
    }, { once: true });

    // Safety timeout: clear loading after 2s regardless, as a last-resort fallback
    setTimeout(() => {
      this.wrapper.classList.remove('loading');
    }, 2000);
  }
}
window.customElements.define('lazy-image', LazyImage, { extends: 'img' });


class ProgPicture extends HTMLPictureElement {
  constructor() {
    super();

    this.abortController = new AbortController();
    this.addEventListener('touchmove', this.touchmove_handler, { signal: this.abortController.signal });
  }

  touchmove_handler(ev) {
    if (ev.scale > 1) {
      var hqImage = this.getAttribute('data-hq');
      this.querySelector('source').setAttribute('srcset', hqImage);
      this.abortController.abort();
    }
  }
}
window.customElements.define('prog-picture', ProgPicture, { extends: 'picture' });